// Containers.jsx
import React, { useState } from "react";
import { useDroppable } from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { ActionIcon, Modal, Button, Flex, Loader, Text } from "@mantine/core";
import { LuTrash } from "react-icons/lu";

import { useStyles } from "./style";
import TaskCard from "./TaskCard";

/* ------------------ DROPPABLE COLUMN ------------------ */
// `loaded` of the column's `count` tasks are loaded; "Load more" asks for the next page
export function Column({
  id,
  title,
  tasks,
  loaded = 0,
  count = 0,
  loading,
  onLoadMore,
  general,
  onDeleteStatus,
}) {
  const { setNodeRef: setDroppableRef } = useDroppable({
    id, // ✅ column id ("TO DO" | "DOING" | "DONE")
  });
  const { classes } = useStyles();
  const [confirmOpen, setConfirmOpen] = useState(false);

  return (
    <div ref={setDroppableRef} className={classes.column}>
      <p className={classes.columnTitle}>
        {title}
        {general === false && onDeleteStatus && (
          <span className="deleteStatusBtn">
            <ActionIcon
              size="xs"
              color="red"
              variant="transparent"
              onClick={() => setConfirmOpen(true)}
            >
              <LuTrash size={14} color="#e03131" />
            </ActionIcon>
          </span>
        )}
      </p>

      <Modal
        opened={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        title={
          <Text sx={{ fontFamily: "Inter", fontSize: 22, fontWeight: 600 }}>
            Delete Status
          </Text>
        }
        size="xl"
        centered
        overlayProps={{ blur: 3 }}
        radius="lg"
        zIndex={1000}
      >
        <Text
          sx={{
            fontFamily: "Inter",
            fontSize: 18,
            fontWeight: 400,
            marginBottom: 20,
          }}
        >
          Are you sure you want to delete the status{" "}
          <strong>"{title}"?</strong>
        </Text>
        <Flex justify="flex-end" gap="sm">
          <Button
            sx={{ width: 122, fontFamily: "Inter" }}
            onClick={() => setConfirmOpen(false)}
          >
            Cancel
          </Button>
          <Button
            color="red"
            sx={{ width: 122, fontFamily: "Inter" }}
            onClick={() => {
              setConfirmOpen(false);
              onDeleteStatus(id);
            }}
          >
            Confirm
          </Button>
        </Flex>
      </Modal>

      <div style={{ minHeight: "200px" }}>
        <SortableContext
          items={tasks?.map((t) => t.id)}
          strategy={verticalListSortingStrategy}
        >
          {tasks?.length === 0 ? (
            loading ? null : (
              <div className={classes.emptyDrop}>Drop task here</div>
            )
          ) : (
            tasks.map((task) => <TaskCard key={task.id} task={task} />)
          )}
        </SortableContext>
        <Flex className={classes.columnFooter}>
          {loading ? (
            <Loader size="sm" color="yellow" />
          ) : (
            count > loaded && (
              <>
                <Text className="shownCount">
                  Showing {loaded} of {count}
                </Text>
                <Button size="xs" variant="default" onClick={onLoadMore}>
                  Load more
                </Button>
              </>
            )
          )}
        </Flex>
      </div>
    </div>
  );
}
